import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import { Button, Checkbox, Icon, Popup } from 'semantic-ui-react';
import { AddedSearches, Property, Search } from './types';
import { useState } from 'react';
import TextField from 'components/ui/TextField';
import { FiAlertTriangle } from 'react-icons/fi';

const Title = styled.div`
  border: 1px solid #333;
  padding: 8px;
`;
interface Props {
  properties: Property[];
  searches: Search[];
  uniqueSearchesOfOrder: Search[];
  setSelectedSearch: (searchId: number, propertyId: number) => void;
  setSelectedSearches: (searchType: string, selected: boolean) => void;
  clientType: any;
  setSearchIntegrationId: (
    searchId: number,
    key: keyof AddedSearches,
    value: any,
    propertyId: number
  ) => void;
  reactivateProperty: (propertyId: number) => void;
}
export default function PropertiesAndSearchesContin(props: Props) {
  return (
    <div style={{ marginTop: 24 }}>
      <div style={{ overflowX: 'auto' }}>
        {props.properties.length > 1 && (
          <div style={{ display: 'flex' }}>
            {props.searches.length > 0 && (
              <Title style={{ backgroundColor: '#f7f4f4', width: 380, flexShrink: 0 }}>Search Type</Title>
            )}
            {props.uniqueSearchesOfOrder.map((s, i) => {
              return (
                <Title
                  style={{
                    display: 'flex',
                    backgroundColor: '#f7f4f4',
                    width: 108,
                    flexShrink: 0,
                    alignItems: 'center',
                  }}
                >
                  <div style={{ paddingRight: 5 }}>{s.searchCode}</div>
                  <Checkbox onClick={(_, { checked }) => props.setSelectedSearches(s.searchCode, checked)} />
                </Title>
              );
            })}
          </div>
        )}
        {props.properties.map((p, i) => {
          return (
            <div style={{ position: 'relative' }}>
              {p.deactivated && (
                <span
                  style={{
                    position: 'absolute',
                    top: 15,
                    left: -30,
                    opacity: 1,
                    zIndex: 2,
                  }}
                >
                  <Popup
                    content="Reactivate"
                    trigger={
                      <Button
                        onClick={() => props.reactivateProperty(p.id)}
                        icon
                        size="mini"
                        compact
                        basic
                        color="green"
                        content="green"
                      >
                        <Icon name="sync" />
                      </Button>
                    }
                  />
                </span>
              )}
              <div style={{ display: 'flex', opacity: p.deactivated ? 0.3 : undefined }}>
                <Title style={{ width: 380, flexShrink: 0 }}>
                  {p.address}, {p.section ? p.section + '-' : ''}
                  {p.block ? p.block : ''}-{p.lot ? p.lot : ''}, <span style={{ fontWeight: 'bold' }}>{p.municipalityType}</span> of {p.city}, {p.county}, {p.state}{' '}
                </Title>
                {props.uniqueSearchesOfOrder.map((s, i) => {
                  const search = props.searches.find(ps => {
                    return ps.searchTypeId === s.searchTypeId && ps.propertyId === p.id;
                  });
                  if (search) {
                    return (
                      <Title
                        style={{
                          width: 108,
                          flexShrink: 0,
                          padding: 0,
                        }}
                      >
                        <div
                          style={{
                            cursor: p.deactivated ? 'not-allowed' : 'pointer',
                            padding: '8px',
                            backgroundColor: search.selected ? '#e1dede' : '#fff',
                            height: !props.clientType ? '100%' : 'auto',
                          }}
                          onClick={() =>
                            !p.deactivated && props.setSelectedSearch(search.id, search.propertyId)
                          }
                        >
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <div>{s.searchCode}</div>
                            {!search.canCreateContin && (
                              <Popup content="Assign-Only search" trigger={<FiAlertTriangle color="red" />} />
                            )}
                          </div>
                          {search.assignedTo && <div style={{fontWeight: 'bold'}}>AssignedTo: {search.assignedTo}</div>}
                          {!search.canCreateContin && !search.assignedTo && <div style={{fontWeight: 'bold'}}>Status: {search.currentStatus}</div>}
                        </div>
                      </div>
                      {props.clientType && !p.deactivated && (
                          <div
                            onClick={e => {
                              e.stopPropagation();
                              e.preventDefault();
                            }}
                            style={{ padding: '4px 8px', borderTop: '1px solid black' }}
                          >
                            <TextField
                              value={
                                props.clientType === 'Accutitle'
                                  ? search.accutitleNumber ?? ''
                                  : search.riversideSearchId ?? ''
                              }
                              label={props.clientType === 'Accutitle' ? 'Accutitle Number:' : 'Riverside Id'}
                              styles={{ marginBottom: 0 }}
                              height={26}
                              width={'76px'}
                              onChange={e => {
                                props.setSearchIntegrationId(
                                  search.id,
                                  props.clientType === 'Accutitle' ? 'accutitleNumber' : 'riversideSearchId',
                                  e.target.value,
                                  p.id
                                );
                              }}
                              onBlur={e => {
                                if (e.target.value?.trim() && !search.selected)
                                  props.setSelectedSearch(search.id, search.propertyId);
                              }}
                            />
                          </div>
                      )}
                    </Title>
                  );
                } else {
                  return <Title style={{ width: 108, flexShrink: 0 }}> </Title>;
                }
              })}
            </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
